import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const dashboardeldConfig: TSPConfig = {
  key: 'dashboardeld',
  name: 'DashboardELD',
  imageName: 'DashboardELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your DashboardELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default dashboardeldConfig;
